import React from 'react';
import { Section } from '../ui/Section';
import { PenTool, Map, Mail, Smartphone, Heart, Shield } from 'lucide-react';
export function Breakdown() {
  const features = [{
    icon: <PenTool className="w-5 h-5" data-id="element-46" />,
    title: '60 prompts progresivos',
    desc: 'Ejercicios de escritura guiada profunda.'
  }, {
    icon: <Map className="w-5 h-5" data-id="element-47" />,
    title: '4 etapas emocionales',
    desc: 'Reconocerte, Tu Historia, Tus Relaciones y Patrones, Tus Miedos y tu Fuerza.'
  }, {
    icon: <Mail className="w-5 h-5" data-id="element-48" />,
    title: '3 ejercicios especiales',
    desc: 'Cartas: a tu niña interior, a quien te lastimó y a tu sombra.'
  }, {
    icon: <Smartphone className="w-5 h-5" data-id="element-49" />,
    title: 'Formato PDF digital',
    desc: 'Optimizado para tablet, celular o impresión.'
  }, {
    icon: <Heart className="w-5 h-5" data-id="element-50" />,
    title: 'Basado en escritura terapéutica',
    desc: 'Técnicas validadas de autoconocimiento, adaptadas para que puedas hacerlas sola, a tu ritmo.'
  }, {
    icon: <Shield className="w-5 h-5" data-id="element-51" />,
    title: 'Kit de Emergencia Emocional',
    desc: 'El único journal en Argentina con técnicas de contención y contactos de crisis reales.'
  }];
  return <Section bgColor="white" data-id="element-52">
      <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-53">
        <div className="flex-1" data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-55">
            Todo lo que necesitás para tu viaje de 60 días
          </h2>
          <p className="mb-10 text-lg text-[#656464]" data-id="element-56">
            Cada página fue diseñada con intención para llevarte de lo suave a
            lo profundo.
          </p>

          <div className="grid sm:grid-cols-2 gap-8" data-id="element-57">
            {features.map((feature, idx) => <div key={idx} className="flex gap-4" data-id="element-58">
                <div className="text-brand-champagne shrink-0 mt-1" data-id="element-59">
                  {feature.icon}
                </div>
                <div data-id="element-60">
                  <h4 className="font-serif text-lg text-brand-dark mb-1" data-id="element-61">
                    {feature.title}
                  </h4>
                  <p className="text-sm text-brand-light leading-relaxed" data-id="element-62">
                    {feature.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 p-6 bg-brand-cream rounded-sm border border-brand-beige" data-id="element-63">
            <p className="text-sm text-brand-dark leading-relaxed" data-id="element-64">
              Este diario está pensado para{' '}
              <strong data-id="element-65">acompañarte durante 60 días</strong>, pero{' '}
              <strong data-id="element-66">podés hacerlo a tu ritmo</strong>. Podés escribir desde
              apps como GoodNotes, Notability o Xodo, o imprimirlo si prefieres
              hacerlo en papel.
            </p>
          </div>
        </div>

        <div className="flex-1 relative w-full" data-id="element-67">
          <div className="grid grid-cols-2 gap-4" data-id="element-68">
            <img src="https://cdn.magicpatterns.com/uploads/4k1FDNn76vwvgh7kt8SQR9/Screenshot_2026-03-26_at_15.50.53.png" alt="Journaling process" className="w-full h-64 object-cover rounded-sm shadow-md mt-8" data-id="element-69" />
            <img src="https://cdn.magicpatterns.com/uploads/cuqSEcqqHmwaHdDK78LY8d/Screenshot_2026-03-26_at_16.02.14.png" alt="Digital tablet journaling" className="w-full h-64 object-cover rounded-sm shadow-md" data-id="element-70" />
          </div>
        </div>
      </div>
    </Section>;
}